import request from '@/utils/request'

const BASE_ROUTE = 'api/v1/location/'
export const getAllStates = () =>
  request({
    url: BASE_ROUTE + 'states',
    method: 'get'
  })

export const getCounties = (stateId: number) =>
  request({
    url: BASE_ROUTE + `fip/state/${stateId}/counties`,
    method: 'get'
  })

export const getZips = (vendorId: number, stateId: number, countyId: number) =>
  request({
    url: BASE_ROUTE + `fip/state/${stateId}/county/${countyId}/zips/${vendorId}`,
    method: 'get'
  })
